import script from "./testTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./testTemplate.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__